import styled from 'styled-components';

export const WebcamErrorBlockingWrap = styled.div`
  font-family: 'Montserrat', sans-serif;
`;

export const Header = styled.div`
  text-align: center;
`;

export const HeaderIcon = styled.img`
  height: 42px;
  width: 42px;
`;

export const Title = styled.div`
  margin-top: 10px;
  font-size: 24px;
  font-weight: 600;
`;

export const SubTitle = styled.div`
  margin-top: 6px;
  color: #6c757d;
  font-size: 16px;
`;

export const CountdownCard = styled.div`
  margin: 18px auto 0;
  background: #fdecec;
  border: 1px solid #f5c2c7;
  border-radius: 4px;
  padding: 16px;
  text-align: center;
  width: 60%;
`;

export const CountdownLabel = styled.div`
  color: #b02a37;
  font-size: 16px;
`;

export const CountdownTime = styled.div`
  margin-top: 6px;
  font-size: 60px;
  font-weight: 700;
  color: #b02a37;
  line-height: 1;
`;

export const CountdownHint = styled.div`
  margin-top: 6px;
  color: #b02a37;
  font-size: 16px;
`;

export const Checklist = styled.ul`
  margin: 14px 0 0;
  padding: 12px 12px 12px 28px;
  background: #f1f3f5;
  border-radius: 4px;
  color: #6c757d;
  font-size: 20px;
  line-height: 24px;
`;

export const ChecklistItem = styled.li`
  margin: 4px 0;
`;
